import { render, staticRenderFns } from "./BonusPoint.vue?vue&type=template&id=73bbc4e1"
import script from "./BonusPoint.vue?vue&type=script&lang=js"
export * from "./BonusPoint.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports